export enum STRIPE_DURATION {
	ONCE = 'once',
	REPEATING = 'repeating',
	FOREVER = 'forever'
}
